import type { BizyPeopleBrowserEntry } from '../../../lib/bizy/types';
import { useBizyPeopleBrowserEntries } from '../../../queries/bizy-people';

// The People Browser sidebar shows at most 5 recent entries (the backend also
// caps this; we slice defensively).
const MAX_ENTRIES = 5;

export interface UseBizyPeopleEntriesResult {
	entries: BizyPeopleBrowserEntry[];
	unreadEntries: BizyPeopleBrowserEntry[];
	unreadCount: number;
	isLoading: boolean;
}

/**
 * Shared People Browser data for the member-facing surfaces (the sidebar list,
 * the compact navigation menu, and the new-segment greeter callout).
 *
 * Wraps the `useBizyPeopleBrowserEntries` query (`GET /bizy/people`) and derives
 * the unread subset. When `enabled` is false the query is disabled and the
 * result is empty.
 */
export function useBizyPeopleEntries(enabled: boolean): UseBizyPeopleEntriesResult {
	const { data, isLoading } = useBizyPeopleBrowserEntries({ enabled });

	if (!enabled) {
		return { entries: [], unreadEntries: [], unreadCount: 0, isLoading: false };
	}

	const entries = (data ?? []).slice(0, MAX_ENTRIES);
	const unreadEntries = entries.filter((entry) => entry.unread);

	return { entries, unreadEntries, unreadCount: unreadEntries.length, isLoading };
}
